import { render } from "./TestimonialsSlider.vue?vue&type=template&id=3b620804"
import script from "./TestimonialsSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__